module.exports = __webpack_public_path__ + "static/media/Icon_765281.96b41260.png";